import { injectable } from 'inversify';
import { queryElements, replaceInnerElement } from '@/app/shared/utils/content-utils';
import * as Api from "@/app/interaction/api";
import { TabsPropData, TabsContent, TabsState } from './tabs-interfaces';
import { createInteractionComponent } from '@/app/interaction/ui'

interface CreateTabsComponentCallback {
  callback: (
    tabId: string,
    title: string,
    tabs: TabsPropData,
    instruction: string|null
  ) => Vue
}

@injectable()
export class IncludeTabsHandler implements Api.IncludeComponentsHandlerInterface {

  public async includeComponents($parsedContent: any): Promise<Vue[]> {

    const verticalCallback
          = (tabId: string, title: string, tabs: TabsPropData, instruction: string|null) => {

        const interactionComponent = createInteractionComponent<TabsContent, TabsState>(tabId,
                                                                                        'vertical-tabs', {
                                                                                          title,
                                                                                          instruction
                                                                                        }, {
                                                                                          tabs
                                                                                        })

        interactionComponent.$mount();


        return interactionComponent;
    }

    const vertical = this.includeTabs(
      '.tab.component.tab--vertical', $parsedContent, { callback: verticalCallback });

    const horizontalCallback
          = (tabId: string, title: string, tabs: TabsPropData, instruction: string|null) => {

        const interactionComponent = createInteractionComponent<TabsContent, TabsState>(tabId,
                                                                                        'horizontal-tabs', {
                                                                                          title,
                                                                                          instruction
                                                                                        }, {
                                                                                          tabs
                                                                                        })

        interactionComponent.$mount();

            
        // const component = this.interactiveComponentFactory(
        //   'horizontal-tabs', 
        //   { 
        //     result: null, state: null,
        //     content: {
        //       tabId, title, instruction, tabs
        //     }
        //   }
        // );  
        // component.$mount();

        return interactionComponent;
      };

    const horizontal = this.includeTabs(
      '.tab.component.tab--horizontal', $parsedContent, { callback: horizontalCallback });

    return [
      ...vertical,
      ...horizontal
    ]
  }

  private includeTabs(
    selector: string,
    $parsedContent: any,
    createComponentCallback: CreateTabsComponentCallback
  ): Vue[] {
    const tabElements: any = queryElements(selector, $parsedContent);
    if (tabElements === null) {
      return [];
    }

    let components: Vue[] = []
    for (const tabElement of tabElements) {
      const $tabElement: any = $(tabElement);
      const tabId: string|undefined = $tabElement.attr('id');
      if (!tabId) {
        continue;
      }

      const component = this.includeTabComponent(tabId, $tabElement, createComponentCallback);
      components.push(component)
    }

    return components
  }

  private includeTabComponent(
    tabId: string,
    $tabElement: any,
    createComponentCallback: CreateTabsComponentCallback
  ) {
    const title: string = $tabElement.find('.tab__title').text() || null;
    const instruction: string|null = $tabElement.find('.tab__instruction').html() || null;
    const $labels: any = $tabElement.find('.tab__label');
    const $contents: any = $tabElement.find('.tab__content');

    const tabs: TabsPropData = {};
    let index: number = 0;
    for (const label of $labels) {
      tabs[$(label).text()] = $contents.eq(index).html();
      index++;
    }

    const component: Vue = createComponentCallback.callback(tabId, title, tabs, instruction);

    const selector: string = `#${tabId}`;
    replaceInnerElement(selector, component.$el);

    return component
  }
}
